import styled from "styled-components";
import LayoutModal from "../Layout/LayoutModal";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";

const AlarmInputCheckBox = ({ handleClickX }) => {
  return (
    <Box>
      <div className="hrz-wrapper center display:flex ">
        <p className="bold-text" style={{ fontSize: "20px" }}>
          필수 입력 항목을 입력해주세요
        </p>
      </div>
      <div className="hrz-wrapper center" style={{ marginTop: "10px" }}>
        <p style={{ color: "#222222" }}>입력하지 않은 필수 항목이 있습니다.</p>
      </div>
      <div className="hrz-wrapper center">
        <p style={{ color: "#222222" }}>다시 한번 체크해주세요.</p>
      </div>

      <div
        className="blueBtn-base center"
        style={{
          marginTop: "30px",
          width: "400px",
          height: "60px",
          borderRadius: "10px",
          fontFamily: "notoSans-medium",
        }}
        onClick={handleClickX}
      >
        확인
      </div>
    </Box>
  );
};

const AlarmInputCheck = ({ handleClickX }) => {
  return (
    <LayoutModal Modal={<AlarmInputCheckBox handleClickX={handleClickX} />} />
  );
};

const Box = styled.div`
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
`;

export default AlarmInputCheck;
